import type { CSSProperties } from "react";

// Entrata leggera degli elementi del builder, la stessa delle righe di DataTable e delle
// card in dashboard: dissolvenza + piccolo scivolamento, sfalsata per indice.
// L'animazione parte solo al mount, quindi va su elementi con key stabile (id attività,
// chiave del giorno): un re-render non la ripete, un cambio di giorno sì.
export const APPEAR_CLASS =
  "motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-1 duration-300";

// Oltre il dodicesimo elemento il ritardo smette di crescere: in una lista lunga
// gli ultimi non devono aspettare mezzo secondo per comparire.
export const appearStyle = (index: number, step = 40): CSSProperties => ({
  animationDelay: `${Math.min(index, 12) * step}ms`,
  animationFillMode: "backwards",
});
